/* eslint-disable quotes */
import PropTypes from "prop-types";
import { Modal, Button } from "react-bootstrap";

export const AI_FUNCTION_CONTENT = {
  "Treatment:Chronology": {
    summaryTitle: "Extract medical treatment chronology from medical bills with this function.",
    description:
      "Each medical provider has a document slot for final medical bills. Upload or move the " +
      "final medical bills for each provider to their medical bill slot and open the document " +
      'by clicking the button. You will then see a button on the bottom right labeled "Extract ' +
      "Chronology\" with a credit cost that will deduct against your firm's balance of AI " +
      "function credits. The Chronology Extraction will extract all treatment dates from the " +
      "medical bills along with CPT Codes and Fees charged for each. You can then edit, alter " +
      "and add notes to each entry, as well as assign treatment date and CPT Code entries to " +
      "individual body parts.",
  },
};

const AIFunctionalityModal = ({
  show,
  handleClose,
  pageName = "Treatment",
  tabName = "Chronology",
  firmName,
  creditBalance,
  summaryTitle,
  description,
}) => {
  const fallback = AI_FUNCTION_CONTENT[`${pageName}:${tabName}`] || {};
  const title = summaryTitle ?? fallback.summaryTitle ?? "";
  const body = description ?? fallback.description ?? "";

  // null / undefined means "not loaded yet", which is not the same as zero credits.
  // Zero has to read as zero — that is the state that blocks the user.
  const hasBalance = creditBalance !== null && creditBalance !== undefined;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="modal-dialog modal-dialog-centered"
      aria-labelledby="ai-functionality-modal-title"
    >
      <Modal.Header className="text-center p-0 height-25 bg-primary popup-heading-color justify-content-center modal-header">
        <Modal.Title
          id="ai-functionality-modal-title"
          style={{ fontSize: "16px", textTransform: "uppercase" }}
        >
          {`${pageName} Page ${tabName} Functionality`}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{ padding: "5px", maxHeight: "60vh", overflowY: "auto" }}
        className="invisible-scrollbar"
      >
        {title && (
          <p
            className="m-b-5"
            style={{ color: "var(--primary)", fontWeight: "600", fontSize: "14px" }}
          >
            {title}
          </p>
        )}

        {body && (
          <p className="m-0" style={{ color: "#000", fontSize: "14px", lineHeight: "1.4" }}>
            {body}
          </p>
        )}

        <div
          className="m-t-5 p-t-5"
          style={{ borderTop: "1px solid var(--primary-10)", fontWeight: "600" }}
        >
          <span style={{ color: "var(--primary-25)" }}>
            {firmName
              ? `${firmName} AI functionality credit balance: `
              : "AI functionality credit balance: "}
          </span>
          <span style={{ color: "var(--primary)" }}>{hasBalance ? creditBalance : "—"}</span>
        </div>
      </Modal.Body>

      <Modal.Footer
        style={{ background: "var(--primary-25)" }}
        className="p-0 mt-0 padding-outside-btn-new-provider justify-content-end"
      >
        <div />
        <Button
          variant="secondary"
          className="button-padding-footer-new-provider d-flex align-items-center justify-content-center btn btn-secondary"
          onClick={handleClose}
        >
          Close
        </Button>
        <div />
      </Modal.Footer>
    </Modal>
  );
};

AIFunctionalityModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  pageName: PropTypes.string,
  tabName: PropTypes.string,
  firmName: PropTypes.string,
  creditBalance: PropTypes.number,
  summaryTitle: PropTypes.string,
  description: PropTypes.string,
};

export default AIFunctionalityModal;
